import { LegalPage } from "../legal/legal-page"
import { privacyContent } from "./privacy-content"

/**
 * Public, unauthenticated Privacy Policy page (route: /privacy).
 * Renders the bilingual legal document with an English / Arabic toggle.
 */
export function PrivacyPage() {
  return (
    <LegalPage
      document={privacyContent}
      metaDescription="Privacy Policy for the Taqat AI Employee Store platform and services."
    />
  )
}
